<template>
    <div class="wizard-body w-[75%] flex-shrink-0 flex-grow-0 max-w-[75%]">
        <div v-if="successMessage" class="overlay" v-show="showSuccessMessage">
            <div class="success-popup">
                <span class="close-button" @click="closeSuccessMessage">&times;</span>
                {{ successMessage }}
            </div>
        </div>

        <div class="header-container">
            <h4 class="text-lg font-medium text-black-900 dark:text-slate-200">
                {{ $t('GENERAL_SETTINGS.DOMESTIC_CALLS.INBOX_TITLE') }}
            </h4>
        </div>

        <form @submit.prevent="createChannel">
            <div class="form-fields">

                <!-- Inbox Name Field -->
                <div class="form-group">
                    <label :class="{ error: $v.name.$error }">
                        {{ $t('GENERAL_SETTINGS.DOMESTIC_CALLS.NAME') }}
                        <input class="inbox_name" type="text" v-model="name" @blur="$v.name.$touch()" placeholder="Enter inbox name here .." />
                        <span v-if="$v.name.$error" class="message">
                            {{ $t('GENERAL_SETTINGS.DOMESTIC_CALLS.ERROR_NAME') }}
                        </span>
                    </label>
                </div>

                <!-- Jio Eva Details Section -->
                <div class="jioeva-setup">
                    <h6 class="text-sm font-semibold text-black-800 dark:text-slate-300">
                        Setup Jio Eva Details
                    </h6>
                    <p class="text-sm text-gray-600 dark:text-gray-400">
                        Please enter the required details to configure Jio Eva Inbox.
                    </p>
                </div>

                <!-- Jio Eva Input Fields with Validation -->
                <div class="form-group" v-for="(value, key) in jioEvaDetails" :key="key">
                    <label :class="{ error: $v.jioEvaDetails[key].$error }">
                        {{ fieldLabels[key] || key }}
                        <input v-model="jioEvaDetails[key]" type="text" class="input" @blur="$v.jioEvaDetails[key].$touch()" :placeholder="`Enter ${fieldLabels[key] || key}`" />
                        <span v-if="$v.jioEvaDetails[key].$error" class="message">
                            {{ `${fieldLabels[key]} is required.` }}
                        </span>
                    </label>
                </div>
            </div>

            <button type="submit" :disabled="$v.$invalid">
                {{ $t('GENERAL_SETTINGS.DOMESTIC_CALLS.SUBMIT') }}
            </button>
        </form>
    </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { mapGetters } from 'vuex';
import router from '../../../../index';

export default {
    data() {
        return {
            name: '',
            successMessage: '',
            showSuccessMessage: true,
            account_id: this.accountId,
            jioEvaDetails: {
                app_id: '',
                app_key: '',
                authorization: '',
                cookie: '',
            },
            fieldLabels: {
                app_id: 'App ID',
                app_key: 'App Key',
                authorization: 'Authorization Token',
                cookie: 'Session Cookie',
            },
        };
    },
    computed: {
        ...mapGetters({
            accountId: 'getCurrentAccountId',
        }),
    },
    validations: {
        name: { required },
        jioEvaDetails: {
            app_id: { required },
            app_key: { required },
            authorization: { required },
            cookie: { required },
        },
    },
    methods: {
        async createChannel() {
            this.$v.$touch();
            if (this.$v.$invalid) {
                return; // Prevent submission if form is invalid
            }

            try {
                const jioEvaChannel = await this.$store.dispatch('inboxes/createJioEvaChannel', {
                    jio_eva: {
                        type: 'jio_eva',
                        name: this.name,
                        accountId: this.accountId,
                        jio_eva_details: { ...this.jioEvaDetails },
                    },
                });

                console.log('JioEva Channel Created:', jioEvaChannel);
                router.replace({
                    name: 'settings_inboxes_add_agents',
                    params: {
                        page: 'new',
                        inbox_id: jioEvaChannel.id,
                    },
                });
            } catch (error) {
                console.error('Error creating JioEva channel:', error);
                this.errorMessage = this.$t('INBOX_MGMT.ADD.JIO_EVA_CHANNEL.API.ERROR_MESSAGE');
            }
        },
        closeSuccessMessage() {
            this.showSuccessMessage = false;
            this.successMessage = '';
        },
    },
};
</script>

<style scoped>
label {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    font-size: 16px;
}

.inbox_name, .input {
    width: 70%;
}

.input {
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 4px;
}

.message {
    color: red;
    font-size: 0.875rem;
}

/* Jio Eva Setup Section */
.jioeva-setup {
    margin-bottom: 1rem;
    padding: 10px;
    background-color: #f8f9fa;
    border-left: 4px solid #007bff;
    border-radius: 4px;
}

/* Disabled Button */
button:disabled {
    background-color: gray;
    cursor: not-allowed;
}

button {
    margin-top: 1rem;
    cursor: pointer;
    background-color: hsl(209 100% 60.6% / 1);
    color: #fff;
    padding: 10px;
    border-radius: 5px;
    border: none;
    font-size: 1rem;
    width: 20%;
}

.overlay {
    position: fixed;
    margin: auto;
    left: 50%;
    transform: translateX(-50%);
    top: 10%;
    width: 250px;
}

.success-popup {
    background-color: #44ce4b;
    color: #fff;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    position: relative;
}

.close-button {
    position: absolute;
    top: 5px;
    right: 10px;
    cursor: pointer;
    font-size: 20px;
}
</style>
